import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

interface ICountdownProps {
  durationInSec: number;
  onEllapsed: () => void;
}

const Countdown = ({ durationInSec, onEllapsed }: ICountdownProps) => {
  const [secondsLeft, setSecondsLeft] = useState(durationInSec);

  useEffect(() => {
    if (secondsLeft > 0) {
      const id = setTimeout(() => {
        if (secondsLeft - 1 <= 0) {
          onEllapsed();
        }
        setSecondsLeft((left) => left - 1);
      }, 1000);

      return () => clearTimeout(id);
    }
  }, [secondsLeft]);

  let minutes = parseInt((secondsLeft / 60).toString());
  let seconds = parseFloat((secondsLeft - minutes * 60).toFixed(0));

  minutes = minutes < 0 ? 0 : minutes;
  seconds = seconds < 0 ? 0 : seconds;

  return (
    <div style={{display: "flex", gap: "6px", alignItems:"center"}}>
      <Typography fontWeight="bold" variant="h6">
        {minutes}:{seconds}
      </Typography>
      <Typography>Munites</Typography>
    </div>
  );
};

export default Countdown;
